import React from "react";
import Container from "../components/misc/Container";
import LayoutHomepage from "../layout/LayoutHomepage";
import DynamicScrollToTop from '../components/misc/DynamicScrollToTop';
import { Link } from "react-router-dom/cjs/react-router-dom.min";


const Partner = () => {
  return (
    <>
    <DynamicScrollToTop/>
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2 mb-6">
              <div className="flex w-full mt-8 mb-8">
                <Link to="/homepage">
                <p className="flex items-center text-font-gray opacity-50">
                  Beranda{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                </Link>
                <h1 className="text-font-gray">Menjadi partner</h1>
               
              </div>
              <div className="py-4 rounded bg-white">
                <div className="flex px-auto  border-gray-300">
                  <div className="flex items-center p-4  ml-auto mr-auto">
                    <h4 className="text-center text-4xl font-semibold text-font-gray mb-2">
                      Kerjasama
                    </h4>
                  </div>
                </div>
                {/* Section Agreement */}
                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="flex items-center p-4">
                    <p className="text-2xl text-center font-semibold text-font-gray mb-2">
                      Kami memberikan beberapa keuntungan berbelanja dg
                      kebutuhan yg lebih banyak & hidup menjadi lebih simple
                    </p>
                  </div>
                </div>
                <hr></hr>
                <div className="flex px-auto  border-gray-300">
                  <div className="flex items-center p-4  ml-auto mr-auto">
                    <h4 className="text-center text-xl font-semibold text-font-gray mb-2">
                      Untuk kerjasama bisnis dg kami, hubungi kami disini :
                    </h4>
                  </div>
                </div>
                <div className="flex px-auto  border-gray-300">
                  <div className="flex items-center p-4  ml-auto mr-auto">
                    <h4 className="text-center text-xl font-semibold text-basic-orange mb-2">
                      sentrablanja@gmail.com
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default Partner;
